import modular from 'modujs';
import * as modules from './modules';
import { html } from './utils/environment';

const app = new modular({
    modules: modules
});

window.isMobile = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

if (window.isMobile) {
    html.classList.add('is-mobile');
} else {
    html.classList.add('is-desktop');
}

window.onload = () => {
    const $style = document.getElementById("stylesheet");

    if ($style.isLoaded) {
        init();
    } else {
        $style.addEventListener('load', () => {
            init();
        });
    }
};

function init() {
    app.init(app);

    html.classList.add('is-loaded');
    html.classList.add('is-ready');
    html.classList.add('is-loading-callback');

    html.classList.remove('is-loading');

    gsap.delayedCall(0.8, () => {
        html.classList.add('is-first-load');

        gsap.delayedCall(0.6, () => {
            html.classList.add('has-dom-ready');

            gsap.delayedCall(0.4, () => {
                html.classList.remove('is-loading-callback');
            });
        });
    });

}

